angular.module('zc.projects')

.directive 'zcCampaignSegmentTableBrief', (CampaignSegment, Meta, $state, lib) ->
  restrict: 'E'
  templateUrl: "/templates/projects.segments/campaign_segment_table_brief.html"
  replace: true
  scope:
    segment: "="
  link: (scope, element, attrs) ->




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_table_brief.directive.coffee